<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <!-- <div class="modal-title">
      {{modalData.title}}
    </div> -->
    <div v-html="modalData.description" class="modal-description"></div>
    <div class="btn-wrapper">
      <div @click="closeModal()" class="btn">
        {{$t('main.close')}}
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'questionmarkModal',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  methods: {
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-description {
    font-size: 16px;
    line-height: 29px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 20px;
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
